module.exports = __webpack_public_path__ + "static/img/introduce_4.e2f5ccc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/hlw/popup/introduce_4.png
// module id = dD+n
// module chunks = 1